import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type {
  IKioscoCodigoVinculacion,
  IKioscoCodigoVinculacionRequest,
  IKioscoDispositivo,
  IKioscoDispositivosResumen,
  IKioscoRevocarRequest,
  IKioscoRevocarResponse,
  IKioscoVigenciaRequest,
  IKioscoVigenciaResponse
} from '../interfaces/IKioscoDispositivo'

// Administración de los kioscos de autoadmisión. Todos los endpoints exigen
// perfil SUPERADMIN en el backend.
export class KioscoDispositivoService extends BaseService<IKioscoDispositivo> {
  constructor() {
    super({
      baseUrl: 'kiosco/dispositivos/'
    })
  }

  async generarCodigo(
    data: IKioscoCodigoVinculacionRequest
  ): Promise<AxiosResponse<IResponseApi<IKioscoCodigoVinculacion>>> {
    return this.http
      .post<IResponseApi<IKioscoCodigoVinculacion>>('/generar-codigo', data)
      .catch(this.errorHandle)
  }

  async listarDispositivos(): Promise<
    AxiosResponse<IResponseApi<IKioscoDispositivosResumen>>
  > {
    return this.http
      .get<IResponseApi<IKioscoDispositivosResumen>>('/list')
      .catch(this.errorHandle)
  }

  async revocar(
    data: IKioscoRevocarRequest
  ): Promise<AxiosResponse<IResponseApi<IKioscoRevocarResponse>>> {
    return this.http
      .post<IResponseApi<IKioscoRevocarResponse>>('/revocar', data)
      .catch(this.errorHandle)
  }

  async actualizarVigencia(
    data: IKioscoVigenciaRequest
  ): Promise<AxiosResponse<IResponseApi<IKioscoVigenciaResponse>>> {
    return this.http
      .put<IResponseApi<IKioscoVigenciaResponse>>('/vigencia', data)
      .catch(this.errorHandle)
  }
}
